import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { PropertyFilterService } from 'src/app/property-filter/service/property-filter.service';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { SaveSearchFacade } from '../../save-search.facade';

@Component({
  selector: 'app-view-search',
  templateUrl: './view-search.component.html',
  styleUrls: ['./view-search.component.scss'],
})
export class ViewSearchComponent implements OnInit {
  @ViewChild('viewSearchDropDown', { static: false }) menu: MatMenuTrigger;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  savedSearchesAndFilters: any[] = [];
  searchType = 'both';
  searchInput: string;
  onDestroyNotifier$ = new Subject();
  companyName: string = '';
  userType: string = '';

  constructor(
    private saveSearchFacade: SaveSearchFacade,
    private authorizeService: AuthorizeService,
    private appState: AppState,
    private userState: UserState,
    public propertyFilterService: PropertyFilterService
  ) {}

  ngOnInit() {
    this.userType = this.userState.userDetails?.userType;
    this.companyName = this.appState && this.appState.companyInfoValue.alias;
  }

  ngAfterViewInit() {}
  openViewSearch() {
    if (this.authorizeService.canAct('savedFilter')) {
      this.searchType = 'both';
      this.searchInput = null;
      this.saveSearchFacade
        .getActiveSaveSearches()
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res) => {
          this.savedSearchesAndFilters = res.filter((value, i) => i < 10);
        });
      this.saveSearchFacade.setOpenedViewSearchStatus(true);
    } else {
      this.trigger.closeMenu();
    }
  }

  rePopulateSavedData(property) {
    if (property?.appliedFilter?.filters) {
      let location = property?.placeDetails?.fullAddress;
      this.propertyFilterService.setPrimaryFilterToUrl(property.appliedFilter.filters, location || null);
    }
    this.trigger.closeMenu();
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
  close() {
    this.trigger.closeMenu();
  }
}
